import { atom } from "jotai";
import { IScanRequest } from "../scanner";

export const printerAtom = atom<IPrinter[]>([]);
export const getPrintersLoadingAtom = atom<boolean>(false);
const localPrinter = localStorage.getItem('printer')
export const selectedPrinterAtom = atom<IPrinter>(localPrinter ? JSON.parse(localPrinter) as IPrinter : {} as IPrinter);
export const lineItemIssuesAtom = atom<ILineItemIssues[]>([]);

// #region IPrinterAssignments
export interface IPrinterAssignments {
    "1x1": IPrinter;
    "4x6": IPrinter;
}

const localPrinterAssignments = localStorage.getItem('printer-assignments');
export const printerAssignmentsAtom = atom<IPrinterAssignments | null>(
    localPrinterAssignments ? JSON.parse(localPrinterAssignments) as IPrinterAssignments : null
);

export interface IPrinter {
    id: number;
    print_node_id: number;
    status: string;
    station_name: string;
    press_forge_print_id: number;
}

export interface ILineItemIssues {
    id: number;
    value: string;
    action: string;
    is_active: boolean;
}

export interface ISubmitLineItemIssueRequest {
    issue_id: number;
    user_id: number;
    scan_request: IScanRequest;
    material_id: number;
    brand_id: number;
}